import { Deserializable } from '../../../protocols/deserializable';
import { CreateWithdrawalInstructionRequest } from '../../../submissions/requests/create-withdrawal-instruction-request';
import { SubmissionRequest } from './submission-request';
import { PaymentMethodTypeEnum } from '../../../enum/shared/payment-method-type-enum';

export class RecurringPaymentInstructionChangeRequest implements Deserializable {
  public paymentStartDate: string;
  public paymentAmount: number;
  public useMinimumAmount: boolean;

  constructor(paymentStartDate: string, paymentAmount: number, useMinimumAmount: boolean) {
    this.paymentStartDate = paymentStartDate;
    this.paymentAmount = paymentAmount;
    this.useMinimumAmount = useMinimumAmount;
  }

  public onDeserialize(): void {}
}

export class LumpSumPaymentInstructionChangeRequest implements Deserializable {
  public desiredPaymentDate: string;
  public paymentAmount: number;

  constructor(desiredPaymentDate: string, paymentAmount: number) {
    this.desiredPaymentDate = desiredPaymentDate;
    this.paymentAmount = paymentAmount;
  }

  public onDeserialize(): void {}
}

export class CreateVariableBenefitPaymentChangeRequest extends SubmissionRequest {
  public minimumAgeSpouseId: number | null = null;
  public minimumAgeDateOfBirth: string | null = null;
  public forgoRecurringPayments: boolean = false;
  public paymentMethodId!: PaymentMethodTypeEnum;
  public bankAccountId!: number;
  public annualRecurringPaymentInstructionChange: RecurringPaymentInstructionChangeRequest | null = null;
  public monthlyRecurringPaymentInstructionChange: RecurringPaymentInstructionChangeRequest | null = null;
  public lumpSumPaymentInstructionChange: LumpSumPaymentInstructionChangeRequest | null = null;
  public withdrawalInstructions: CreateWithdrawalInstructionRequest[] = [];
}
